import { useRef } from 'react';
import Image from 'next/image';
import Button from '../ui/Button';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import useFormStore from "../../stores/FormStore.jsx";
import LinkLikeButton from "../ui/LinkLikeButton";


const ServicesCTA = ({title, desc, image, btn_text, lang, menu}) => {

  const sectionRef = useRef(null);      
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const buttonRef = useRef(null);
  const {
      openPopUp, setOpenPopUp
  } = useFormStore();


  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {
      gsap.fromTo(titleRef.current, { opacity: 0, y: '2rem' }, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
        },
      });

      gsap.fromTo(textRef.current, { opacity: 0, y: '2rem' }, {
        opacity: 1,
        y: 0,
        delay: 0.2,
        duration: 0.5,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
        },
      });

      gsap.fromTo(buttonRef.current, { opacity: 0, y: '2rem' }, {
        opacity: 1,
        y: 0,
        delay: 0.4,
        duration: 0.5,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
        },
      });


    });

    return () => mm.revert();
  }, {scope: sectionRef});


  return (
    <section ref={sectionRef} className="container-max w-full relative">
            <div  className="mb-[2.4rem] flex items-center overflow-hidden justify-center md:mb-[4rem] lg:mb-[8rem] w-full relative h-[32rem] md:h-[40rem] lg:md:h-auto lg:aspect-[1/0.32]">
              <div className='relative h-full lg:h-[100%] w-full'>
                <Image
                  src={image?.url}
                  alt={image?.alt}
                  fill
                  sizes="100vw"
                  quality={85}
                  className="w-auto object-cover"
                />
              </div>

              
            <div  className='container-padding absolute inset-0 text-center flex flex-col justify-center items-center'>
              <h2 ref={titleRef} className='heading-3 mb-[1.2rem] md:mb-[2rem] lg:mb-[2.4rem] [&>.selected]:italic [&>.selected]:text-dusty-blue-light' dangerouslySetInnerHTML={{__html: title}}/>
              <p ref={textRef} className='text-1 max-w-[50rem] mb-[3.2rem] md:mb-[4rem]'>{desc}</p>
              <div ref={buttonRef}>
                {lang === 'en' ? (menu && (
                    <LinkLikeButton trianglesColorClass={'bg-sky-blue'} className="w-fit" isFullSized={true} href={menu?.link}>
                      {btn_text}
                      <svg className='' width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/></svg>
                    </LinkLikeButton>
                )) : (
                    <Button onClick={() => {setOpenPopUp(true)}} className="w-fit" trianglesColorClass={'bg-sky-blue'} isFullSized={true}>
                      {btn_text}
                      <svg className='' width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/></svg>
                    </Button>
                )}
              </div>
            </div>
            </div>

    </section>
  );
};

export default ServicesCTA;